module.exports = __webpack_public_path__ + "static/media/invoice.31e368e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/invoice.png
// module id = 301
// module chunks = 0